import type { TranslationKeys } from './keys';
import { ru } from './ru';
import { en } from './en';

export type { TranslationKeys } from './keys';
export { ru } from './ru';
export { en } from './en';

export const getTranslations = (languageCode: string): TranslationKeys => {
  switch (languageCode) {
    case 'en-US':
      return en;
    case 'ru-RU':
    default:
      return ru;
  }
};
